import { ApiProblem } from "../lib/api/client";

/**
 * Calm, safe copy for a refused sign-in step. It never says which detail was
 * wrong, so it gives nothing away about which accounts exist.
 */
export function signInFailureMessage(error: unknown, step: "credentials" | "code" | "passkey"): string {
  if (error instanceof ApiProblem) {
    if (error.unreachable) {
      return "BurgePOS can't be reached. Check this device's connection and try again.";
    }
    if (error.status === 429) {
      const minutes = Math.max(1, Math.ceil((error.retryAfterSeconds ?? 60) / 60));
      return `Too many attempts. Try again in ${minutes} ${minutes === 1 ? "minute" : "minutes"}.`;
    }
    if (error.status === 401) {
      if (step === "passkey") return "That passkey was not accepted. Try again, or start again.";
      return step === "credentials"
        ? "We could not verify those details. Check them and try again."
        : "That code was not accepted. Check your authenticator app and try again, or start again.";
    }
  }
  return "Sign-in is not available right now. Try again in a few minutes.";
}
